export const RETAILERS_SECTIONS = ["retailers"] as const;

export type RetailersSection = (typeof RETAILERS_SECTIONS)[number];

export function isRetailersSection(
  value: string | undefined,
): value is RetailersSection {
  return (
    typeof value === "string" &&
    (RETAILERS_SECTIONS as readonly string[]).includes(value)
  );
}
